export const SNOWPLOW_APP_ID = 'genially-webapp';
export const SNOWPLOW_MINI_COLLECTOR = 'https://com-genially-prod1.mini.snplow.net';
export const SNOWPLOW_PRODUCTION_COLLECTOR = 'https://sp.genially.com';
